export default "__VITE_ASSET__ff6ff527__"